import { lazy, Suspense } from 'react'
import PageMeta from 'src/_shared/components/PageMeta'
import Hero from 'src/pages/VoltNow/components/Hero'

const CallToActionSection = lazy(() => import('src/_shared/components/CallToActionSection'))
const ChargingFlow = lazy(() => import('src/pages/VoltNow/components/ChargingFlow'))
const Compatibility = lazy(() => import('src/_shared/components/Compatibility'))
const Dashboard = lazy(() => import('src/pages/VoltNow/components/Dashboard'))

export const VoltNow = (): JSX.Element => {
	return (
		<>
			<PageMeta
				title="VoltNow - EV Charging App for Seamless Journeys"
				description="VoltNow is a user-friendly EV charging web-app that simplifies the charging process, providing real-time data and a seamless experience for electric vehicle drivers without requiring them to sign up."
			/>
			<Hero />
			<Suspense fallback={<></>}>
				<ChargingFlow />
				<Dashboard />
				<Compatibility page="VoltNow" />
				<CallToActionSection />
			</Suspense>
		</>
	)
}
